import axios from "axios";
import CryptoJS from "crypto-js";
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { handleLogOut } from "../../App";
import { base_url } from "../../constants";
import TableofContent from "./components/TableofContent/TableofContent";
// import { Videos } from "./libs/Videos";
import ContentLoader from "react-content-loader";
import { useDispatch } from "react-redux";
import { showToogleTooltib } from "../../store/reducers/tooltibReducer";
import "./style.css";
const CourseContent = () => {
  const localData = localStorage.getItem("elmataryapp");
  const decryptedBytes = localData && CryptoJS.AES.decrypt(localData, "111");
  const userData =
    decryptedBytes && JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  const [Videos, setVideos] = useState([]);
  const [index, setIndex] = useState(0);
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [checkOwn, setCheckOwn] = useState("loading");
  const [courseDetails, setCourseDetails] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const getUnitData = () => {
    setLoading(true);
    const data_send = {
      student_id: userData?.student_id,
      token_value: userData?.token_value,
      course_id: params.get("course_id"),
    };
    axios
      .post(
        base_url + "/user/courses/select_course_lesson.php",
        JSON.stringify(data_send)
      )
      .then(async (res) => {
        if (res.data.status == "success") {
          const videosData = res.data.message.map((unit) => ({
            id: unit.unit_id,
            title: unit.unit_name,
            videos: unit.videos.map((video) => ({
              ...video,
              id: video.video_id,
              name: video.video_title,
              link_video: video.youtube_id,
              loom_url: video?.loom_url,
            })),
          }));
          console.log(videosData);
          setCheckOwn(
            res?.data?.message[0]?.videos[0]?.own ||
              res?.data?.message[0]?.free == "1"
          );
          setVideos(videosData);
          let allcourses = [...res.data.message];
          let pushedData = [];
          for (let i = 0; i < allcourses.length; i++) {
            let obj = {
              ...allcourses[i],
              show: false,
            };
            pushedData.push(obj);
          }
          setCourseDetails(pushedData);
        } else if (res.data.status === "out") {
          localStorage.clear();

          window.location.reload();
        } else {
          dispatch(showToogleTooltib());
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUnitData();
  }, []);
  const [selectedVideo, setSelectedVideo] = useState({
    objId: 1,
    videoId: 1,
  });

  useEffect(() => {
    if (Videos?.length) {
      console.log(Videos[0]?.videos[0]);
      setSelectedVideo({ ...selectedVideo, videoId: Videos[0]?.videos[0]?.id });
    }
  }, [Videos]);

  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (Videos && Videos?.length) {
      //   const filteredObject = Videos.filter(
      //     (videoObj) => videoObj.id === selectedVideo.objId
      //   );
      //   console.log("filteredObject", filteredObject);
      //   let filteredVideo = filteredObject.map((videos) =>
      //     videos.videos.filter((video) => video.id === selectedVideo.videoId)
      //   );
      //   setVideoObj(filteredVideo.flat()[0]);
      //   setListOfVideos(filteredObject[0]?.videos?.length);
    }
  }, [Videos, selectedVideo]);

  // Memoize videoObj to prevent unnecessary re-renders
  const videoObj = useMemo(() => {
    return Videos[tab]?.videos[index] || {};
  }, [index, tab, Videos]);

  function handleSelectVideo(objId, videoId, title, LessonName) {
    setSelectedVideo({ objId, videoId });
  }

  function handleNextVideo() {
    if (index < Videos[tab]?.videos?.length - 1) {
      setIndex((prevState) => {
        return ++prevState;
      });
    } else {
      if (tab < Videos?.length - 1) {
        setTab((prevState) => {
          return ++prevState;
        });
        setIndex(0);
      }
    }
  }

  function handlePrevVideo() {
    if (index >= 1) {
      setIndex((prevState) => {
        return --prevState;
      });
    } else {
      if (tab >= 1) {
        setTab((prevState) => {
          return --prevState;
        });
      }
    }
  }

  return (
    <>
      {" "}
      {checkOwn == "loading" ? (
        <ContentLoader
          viewBox="0 0 980 420"
          speed={1}
          // backgroundColor={'green'}
        >
          {/* Card shapes */}
          <rect x="10" y="10" rx="20" ry="20" width="960" height="600" />
          {/* <rect x="350" y="10" rx="20" ry="20" width="260" height="300" /> */}
          {/* <rect x="690" y="10" rx="20" ry="20" width="260" height="300" /> */}
          {/* <rect x="690" y="10" rx="20" ry="20" width="260" height="300" /> */}
        </ContentLoader>
      ) : Videos && Videos?.length ? (
        <div>
          {checkOwn == "loading" ? (
            <ContentLoader
              viewBox="0 0 980 420"
              speed={1}
              // backgroundColor={'green'}
            >
              {/* Card shapes */}
              <rect x="10" y="10" rx="20" ry="20" width="960" height="600" />
              {/* <rect x="350" y="10" rx="20" ry="20" width="260" height="300" /> */}
              {/* <rect x="690" y="10" rx="20" ry="20" width="260" height="300" /> */}
              {/* <rect x="690" y="10" rx="20" ry="20" width="260" height="300" /> */}
            </ContentLoader>
          ) : checkOwn ? (
            <>
              {" "}
              <div className="courseContent">
                {loading ? (
                  <ContentLoader
                    viewBox="0 0 980 320"
                    speed={1}
                    // backgroundColor={'green'}
                  >
                    {/* Card shapes */}
                    <rect
                      x="10"
                      y="10"
                      rx="20"
                      ry="20"
                      width="260"
                      height="300"
                    />
                    <rect
                      x="350"
                      y="10"
                      rx="20"
                      ry="20"
                      width="260"
                      height="300"
                    />
                    <rect
                      x="690"
                      y="10"
                      rx="20"
                      ry="20"
                      width="260"
                      height="300"
                    />
                    <rect
                      x="690"
                      y="10"
                      rx="20"
                      ry="20"
                      width="260"
                      height="300"
                    />
                  </ContentLoader>
                ) : (
                  <main>
                    <div className="w-full flex flex-col md:flex-row items-center justify-between gap-8 p-8 bg-white/40 backdrop-blur-2xl border border-white/60 shadow-[0_32px_64px_-16px_rgba(0,0,0,0.08)] relative overflow-hidden group/header">
                      {/* Decorative background element */}
                      <div className="absolute -right-24 -top-24 w-64 h-64 bg-emerald-100/30 rounded-full blur-3xl -z-10 group-hover/header:bg-emerald-200/40 transition-colors duration-1000" />

                      {/* Lesson Information (Left Side) */}
                      <div className="flex items-center space-x-6 z-10 w-full md:w-auto">
                        <button
                          onClick={() => setShowTable(!showTable)}
                          className={`group relative p-4 rounded-2xl transition-all duration-500 shadow-sm flex-shrink-0 ${
                            showTable
                              ? "bg-[#27be9f] text-white rotate-180 ring-8 ring-emerald-50/50"
                              : "bg-white text-slate-400 hover:text-[#27be9f] hover:shadow-xl border border-slate-100"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <line x1="21" y1="10" x2="3" y2="10" />
                            <line x1="21" y1="6" x2="3" y2="6" />
                            <line x1="21" y1="14" x2="3" y2="14" />
                            <line x1="21" y1="18" x2="3" y2="18" />
                          </svg>
                          <span className="absolute -top-12 left-1/2 -translate-x-1/2 px-4 py-2 bg-slate-900 text-white text-[10px] rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap font-black tracking-widest translate-y-2 group-hover:translate-y-0">
                            {showTable ? "HIDE PLAYLIST" : "SHOW PLAYLIST"}
                          </span>
                        </button>

                        <div className="flex flex-col min-w-0">
                          <div className="flex items-center gap-3 mb-2">
                            <div className="flex h-2.5 w-2.5 relative">
                              <div className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></div>
                              <div className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#27be9f]"></div>
                            </div>
                            <span className="text-[11px] uppercase tracking-[0.4em] font-black text-slate-400/80 select-none">
                              Now Playing
                            </span>
                          </div>
                          <h2 className="m-0 font-black text-slate-800 text-2xl lg:text-4xl tracking-tight leading-none italic truncate py-1">
                            {videoObj?.name || "Select a video"}
                          </h2>
                        </div>
                      </div>

                      {/* PDF Action Button (Right Side) */}
                      <button
                        onClick={() =>
                          window.open(
                            location?.state?.course?.pdf_url,
                            "_blanck"
                          )
                        }
                        className="group relative overflow-hidden flex items-center space-x-5 bg-[#27be9f] hover:bg-[#1faa8d] text-white px-3 py-2 rounded-3xl transition-all duration-500 shadow-[0_20px_40px_-12px_rgba(39,190,159,0.4)] hover:shadow-[0_30px_60px_-15px_rgba(39,190,159,0.5)] hover:-translate-y-2 active:scale-95 w-full md:w-auto justify-center z-10"
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full group-hover:animate-[shimmer_2s_infinite]" />

                        <div className="flex flex-col items-end translate-y-0.5">
                          <span className="font-black tracking-tight text-xl italic">
                            PDF Questions
                          </span>
                        </div>

                        <div className="bg-white/20 p-3 rounded-2xl group-hover:bg-white group-hover:text-[#27be9f] group-hover:rotate-6 transition-all duration-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                            <polyline points="14 2 14 8 20 8" />
                            <path d="M8 13h8" />
                            <path d="M8 17h8" />
                            <path d="M10 9H8" />
                          </svg>
                        </div>
                      </button>
                    </div>

                    <div className="videos">
                      <TableofContent
                        handlePrevVideo={handlePrevVideo}
                        handleNextVideo={handleNextVideo}
                        setTab={setTab}
                        tab={tab}
                        showContent={showTable}
                        setShowTable={setShowTable}
                        videoObj={videoObj}
                        Videos={Videos}
                        index={index}
                        setIndex={setIndex}
                        selectedVideo={selectedVideo}
                        handleSelectVideo={handleSelectVideo}
                      />
                    </div>
                  </main>
                )}
              </div>
            </>
          ) : (
            <h2 style={{ padding: "20px", fontWeight: "900" }}>
              You Are Not Register This Course
            </h2>
          )}
        </div>
      ) : (
        <h2 style={{ padding: "20px", fontWeight: "900" }}>
          No Lessons In This Course
        </h2>
      )}
    </>
  );
};

export default CourseContent;
